import React from 'react';
import ReactDOM from 'react-dom';
import ReactTabGroup from './react-tab-group.jsx';

const sections = [
  {
    url: 'mocks/section-1.json',
    params: {
      norce: 'hello'
    }
  },
  {
    url: 'mocks/section-2.json',
    params: {
      norce: 'world'
    }
  },
  {
    url: 'mocks/section-3.json',
    params: {
      norce: 'abcde'
    }
  }
];

ReactDOM.render(<ReactTabGroup onSwitch={(index) => console.log(index)} />, document.getElementById('react-tabbar'));
ReactDOM.render(<ReactTabGroup sections={sections} onSwitch={(index) => console.log(index)} />, document.getElementById('react-tabbar-async'));



/** WEBPACK FOOTER **
 ** ./src/javascript/react-tab-group-example.jsx
 **/